import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextInputField } from '../../../components/FormCom/FormField';
import useGetDriverPerformance from '../../../hooks/dashboard/driver-performance.ts/useGetDriverPerformance';
import {
  DriverPerformanceSearchInitialValues,
  DriverPerformanceSearchSchema,
} from '../../../models/dashboard/driver-performance/driver-performance-search';
import { DRIVER_PERFORMANCE_REPORT } from '../../../routes/routeConstants';

const DriverPerformanceSearch = () => {
  const { getDriverPerformance, loading } = useGetDriverPerformance();

  const onSubmit = (value: any, actions: any) => {
    getDriverPerformance(value.ninNumber, DRIVER_PERFORMANCE_REPORT, () => {
      actions.resetForm(DriverPerformanceSearchInitialValues);
    });
  };

  return (
    <Container>
      <Header>Driver Performance Search</Header>
      <Description>
        Enter a NIN to view the riders performance details within your company
      </Description>
      <FormComponent
        initialValues={DriverPerformanceSearchInitialValues}
        schema={DriverPerformanceSearchSchema}
        onSubmit={onSubmit}
      >
        <FormRow>
          <TextInputField
            name='ninNumber'
            id='ninNumber'
            type='text'
            placeholder='Enter driver NIN...'
          />
          <FormSubmitButton loading={loading}>Proceed</FormSubmitButton>
        </FormRow>
      </FormComponent>
    </Container>
  );
};

export default DriverPerformanceSearch;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 712px;
  border-radius: 5px;
  background-color: #fff;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
`;
